import React from "react";
//#region types
import { StyleEnums } from "models/enums";
import { AutomaticReminderBannerProps } from "models/propTypes/invoicePropTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { Banner, GridR, StyledButton, useCheckRelations } from "components/common";
import { Grid } from "@mui/material";
import { useInvoiceService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const AutomaticReminderBanner: React.FC<AutomaticReminderBannerProps> = (props) => {
  const invoiceService = useInvoiceService();
  const { invoiceId, reloadHandler } = props;

  const onDisableAutomaticReminders = async () => {
    await invoiceService.disableAutomaticReminders(invoiceId);
    reloadHandler && reloadHandler();
  };

  const { getIsReadonlyUser } = useCheckRelations();

  if (getIsReadonlyUser()) {
    return <></>;
  }

  return (
    <Banner
      title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.AutomaticReminder)}
      icon={IconDefinitionConstants.WBolt}
      type={StyleEnums.DisplayType.Info}
    >
      <GridR container direction="column" spacing={3}>
        <Grid item>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.AutomaticReminderDescription)}
        </Grid>
        <Grid item>
          <StyledButton size="sm" displayType={StyleEnums.DisplayType.Info} onClick={onDisableAutomaticReminders}>
            {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.AutomaticReminderDisable)}
          </StyledButton>
        </Grid>
      </GridR>
    </Banner>
  );
};

export default AutomaticReminderBanner;
